import InvoiceForContactDatagrid from 'src/components/EntityDatagrids/InvoiceForContactDatagrid';

const InvoicesContactPage = () => (<InvoiceForContactDatagrid />);
export default InvoicesContactPage;
